import { enableProdMode, importProvidersFrom, APP_INITIALIZER } from '@angular/core';
import { environment } from './environments/environment';
import { provideHttpClient } from '@angular/common/http';
import { BrowserModule, bootstrapApplication } from '@angular/platform-browser';
import { provideAnimations } from '@angular/platform-browser/animations';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRouting } from 'src/routing/app-routing.module';
import { HighchartsChartModule } from 'highcharts-angular';
import { AppComponent } from './components/app.component';
import { CalAngularModule } from '@cvx/cal-angular';
import { AppConfigService } from 'src/services/appconfig.service';

if (environment.production) {
  enableProdMode();
}


export function initializeApp(appConfigService: AppConfigService) {
  return (): Promise<boolean> => {
    return appConfigService.init();
  };
}

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            BrowserModule, 
            FormsModule, 
            ReactiveFormsModule, 
            AppRouting, 
            HighchartsChartModule,
            CalAngularModule.forRoot('assets/config.json')
        ),
        provideAnimations(),
        provideHttpClient(),
        // Initialize app config before the app starts
        {
          provide: APP_INITIALIZER,
          useFactory: initializeApp,
          deps: [AppConfigService],
          multi: true
        }
    ]
})
.catch(err => console.error(err));
